/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_NewInputs */

const cs_projects_new = /** @type {(inputs: Projects_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový projekt`)
};

const en_projects_new = /** @type {(inputs: Projects_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New project`)
};

/**
* | output |
* | --- |
* | "New project" |
*
* @param {Projects_NewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_new = /** @type {((inputs?: Projects_NewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_NewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_new(inputs)
	return cs_projects_new(inputs)
});